/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from "react"
import PropTypes from "prop-types"
import { useStaticQuery, graphql } from "gatsby"
import { FirebaseContext, useAuth } from "./firebase"
import Paper from "@material-ui/core/Paper"
import Container from "@material-ui/core/Container"

import Header from "./header"
import "./layout.css"

const Layout = ({ children }) => {
  const { user, firebase, loading } = useAuth()

  const data = useStaticQuery(graphql`
    query SiteTitleQuery {
      site {
        siteMetadata {
          title
        }
      }
    }
  `)

  return (
    <FirebaseContext.Provider value={{ user, firebase, loading }}>
      <Header siteTitle={data.site.siteMetadata.title} />

      <Paper elevation={4} style={{ minHeight: "400px" }}>
        <main>
          <Container style={{ height: "100%" }}>{children}</Container>
        </main>
      </Paper>
      <footer>© {new Date().getFullYear()} TheFinalScores</footer>
    </FirebaseContext.Provider>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
